export default {
    issues: {
        title: "Tutte le issue",
        subtitle: "{{count}} issue su tutti i container",
        subtitle_plural: "{{count}} issue su tutti i container",
        intro:
            "Qui trovi la coda delle eccezioni operative: problemi strutturati legati a container o documenti (documenti mancanti, controlli di validazione, ritardi e altro).",
        bulletTiles:
            "Le riquadri riassuntivi in alto filtrano la tabella per categorie frequenti (documenti mancanti, controlli singoli, incroci, altre).",
        bulletFilters:
            "La barra filtri consente gravità, stato, categoria, tipo, ricerca, solo bloccanti, issue risolte e intervallo date (ETA/ETD del container — vedi l’icona info accanto alle date).",
        bulletTable: "Clicca una riga per aprire la scheda container con la tab Issue e intervenire con tutto il contesto.",
        reviewContrast:
            "Le conferme umane (identificazione, assegnazione documenti) stanno nel <reviewLink>Centro revisioni</reviewLink> — è diverso da questo elenco di issue operative.",
    },
    reviewCenter: {
        sidebarListTitle: "Voci n. {{count}}",
        sidebarListTitleLoading: "Voci",
        title: "Centro revisioni",
        intro:
            "Una coda breve in cui il sistema chiede una decisione umana prima che i dati siano considerati attendibili: identificazione container, assegnazione documenti, controlli sul tracking e conferme simili. Svuotarla con regolarità mantiene affidabile l’automazione a valle.",
        step1: "Scegli un container dall’elenco a sinistra (gli elementi in sospeso sono evidenziati).",
        step2: "In Identificazione verifica o modifica i campi, rispondi alle domande dell’agente se presenti, poi risolvi o ignora.",
        step3: "In Documenti mantieni, riclassifica, rimuovi o sposta i documenti; unisci i duplicati quando suggerito.",
        step4: "Apri email o anteprime documenti dal pannello di dettaglio quando ti serve il contesto sorgente.",
        vsIssues:
            "Per problemi operativi strutturati su spedizioni e documenti usa <issuesLink>Issue</issuesLink>.",
    },
};
